import { defaultTheme } from "../../../config/theme";

const defaultData = {
    primaryColor: "#fea11d",
    errorColor: "#ff4d4f",
    successColor: "#52c41a",
    warningColor: "#faad14",
    infoColor: "#faad14",
    fontFamily: "sans-serif",
    darkHeader: "true",
    darkMenu: "false",
    lightColor: "#1890ff",
    darkColor: "#1890ff",
    login: null,
    logo: null,
};

const defaultState = {
    data: defaultTheme,
    timestamp: null,
    loading: false,
    error: null,
    success: false,
    loaded: false,
};

const main = (state = defaultState, action) => {
    switch (action.type) {
        case "UNRESTRICTED_THEME_SUCCESS":
            return {
                ...state,
                loading: false,
                error: null,
                data: {
                    ...defaultData,
                    ...action.data,
                },
                timestamp: Date.now().valueOf() / 1000,
                loaded: true,
            };
        case "UNRESTRICTED_THEME_LOADING":
            return {
                ...state,
                error: null,
                loading: true,
                loaded: false,
            };
        case "UNRESTRICTED_THEME_ERROR":
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        case "UNRESTRICTED_THEME_RESET":
            return defaultState;

        default:
            return state;
    }
};

export default main;
